// extracted by mini-css-extract-plugin
export var cons = "sectionProsAndCons-module--cons--8a5c3";
export var section = "sectionProsAndCons-module--section--28b56";
export var topText = "sectionProsAndCons-module--topText--c3eba";
export var wrapper = "sectionProsAndCons-module--wrapper--83781";